var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavHomeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 465",
    style: {
      fill: "none"
    },
    d: "M0 0h26v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 134",
    d: "M25.026 14.816a1.558 1.558 0 0 0-.517-.9q-5.1-4.935-10.2-9.876a2.578 2.578 0 0 0-3.917.018q-3.13 3.121-6.25 6.242c-1.234 1.234-2.473 2.464-3.7 3.706a1.39 1.39 0 0 0-.431 1.1c0 .036-.011.071-.011.108v.788a1.225 1.225 0 0 0 1.225 1.225h1.654v7.276a2.053 2.053 0 0 0 2.053 2.053h5.03l-.031-6.422a.36.36 0 0 1 .358-.36l4.48-.022a.36.36 0 0 1 .361.357l.033 6.447h5a2.053 2.053 0 0 0 2.053-2.053v-6.745l.078-.523h1.577A1.225 1.225 0 0 0 25.1 16.01v-.788a1.211 1.211 0 0 0-.074-.406",
    transform: "translate(.45 -1.864)",
    style: {
      fill: "#111",
      opacity: 0.3
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHomeOff);
export default __webpack_public_path__ + "static/media/nav_home_off.1ddae76dd712f0ec4cead0c2a6efbee9.svg";
export { ForwardRef as ReactComponent };